import React from 'react';
import { Activity, Battery, Heart, Scale, Smile, Zap } from 'lucide-react';
export function WhatWeHelpWith() {
  const items = [{
    icon: Activity,
    label: 'Blood Sugar Balance',
    color: 'bg-blue-50 text-blue-600'
  }, {
    icon: Heart,
    label: 'Cholesterol Improvement',
    color: 'bg-rose-50 text-rose-600'
  }, {
    icon: Smile,
    label: 'Gut Health & Digestion',
    color: 'bg-amber-50 text-amber-600'
  }, {
    icon: Zap,
    label: 'Cravings Control',
    color: 'bg-purple-50 text-purple-600'
  }, {
    icon: Scale,
    label: 'Recovery from Yo-Yo Dieting',
    color: 'bg-emerald-50 text-emerald-600'
  }, {
    icon: Battery,
    label: 'Energy & Vitality',
    color: 'bg-orange-50 text-orange-600'
  }];
  return <section className="py-24 bg-stone-50" data-id="element-159">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-161">
          <div data-id="element-162">
            <h2 className="font-serif text-3xl font-bold text-stone-900 sm:text-4xl mb-6" data-id="element-163">
              More than just weight loss.
              <br data-id="element-164" />
              <span className="text-stone-500" data-id="element-165">
                We focus on whole-body health.
              </span>
            </h2>
            <p className="text-lg text-stone-600 mb-8 leading-relaxed" data-id="element-166">
              Our evidence-based approach addresses the root causes of your
              health concerns. We look at the whole picture—sleep, stress,
              movement, and nutrition—to help you feel your best.
            </p>
            <div className="p-6 bg-white rounded-2xl border border-stone-100 shadow-sm" data-id="element-167">
              <p className="font-serif text-xl italic text-stone-800 mb-4" data-id="element-168">
                "I finally understand what my body needs. My energy is back and
                I'm not obsessing over every meal."
              </p>
              <div className="flex items-center gap-3" data-id="element-169">
                <div className="h-10 w-10 rounded-full bg-stone-200" data-id="element-170" />
                <div data-id="element-171">
                  <p className="font-bold text-sm text-stone-900" data-id="element-172">Sarah J.</p>
                  <p className="text-xs text-stone-500" data-id="element-173">Client since 2023</p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-174">
            {items.map((item, index) => <div key={index} className="flex flex-col items-center justify-center p-6 rounded-2xl text-center bg-white shadow-sm border border-stone-100" data-id="element-175">
                <div className={`h-12 w-12 rounded-full flex items-center justify-center mb-4 ${item.color}`} data-id="element-176">
                  <item.icon className="h-6 w-6" data-id="element-177" />
                </div>
                <p className="font-medium text-stone-900" data-id="element-178">{item.label}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}